// Translations
import form from '../sections/form/translations/ar'

// Translation: Reset > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
